// LoadingState — a small ink pulse shown while a screen waits on its first
// data, replacing the bare "Loading…" text. Inline (stacks pulse over label);
// drop it inside a screen's existing centered loading wrapper. The ping is
// killed for reduced-motion users by the global animation guard.
export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return (
    <span className="inline-flex flex-col items-center gap-3">
      <span className="relative flex size-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-accent opacity-30 animate-ping" />
        <span className="relative inline-flex size-2.5 rounded-full bg-accent" />
      </span>
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-fg-faint">
        {label}…
      </span>
    </span>
  );
}
